export default "__VITE_ASSET__CnmZeGsK__"